import React from "react";
import ReactDOM from "react-dom";
import Routing from "./Routing";

ReactDOM.render(
  <>
    <Routing />
  </>,
  document.getElementById("root")
);
